
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {UserService } from './Services/userservice.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private userService: UserService, private router: Router) {}

  /*canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {


      //console.log(this.userService.isLoggedIn());
      //console.log('go to login if not autheticated');
      
      if (!this.userService.isLoggedIn()) {
        this.userService.logout();
        this.router.navigate(['/login']); // go to login if not authenticated
        return false;
      }
      
    return true;
  }*/

  canActivate(): Observable<boolean> | boolean {

    const token = localStorage.getItem("token")
    /*this.userService.verifyToken(token).subscribe(
      result => {
        // debes validar la estructura de datos que llega en el result
        if(result?.code) {
         // aqui returnas el true
         const token = localStorage.getItem('token')
         const payload = atob(token.split('.')[1]); // decode payload of token
         const parsedPayload = JSON.parse(payload); // convert payload into an Object
     
         //return token
         return parsedPayload.exp > Date.now() / 1000; // check if token is expired
        } else {
            //this._session.deleteData();
            this.router.navigate(['/login']);
            return false;
        }
   });*/
    
    //console.log('Esta entrando aqui', this.userService.isLoggedIn());

    if (!this.userService.isLoggedIn()) {
      //this.userService.logout();
      this.router.navigate(['/login']); // go to login if not authenticated
    }
    return this.userService.isLoggedIn();

    
  }


}